export const getAccessToken = (state) => state.user.accessToken;
export const getUserError = (state) => state.user.error;
export const getUserInfo = (state) => state.user;
export const getActiveTime = (state) => state.user.activeTime;
export const getUserCourses = (state) => state.user.courses;
export const getUserChats = (state) => state.user.chats;
export const getUserId = (state) => state.user.userId;
export const getUserType = (state) => state.user.userType;
export const getUserNotes = (state) => state.user.notes;
